import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-200 bg-white/60 backdrop-blur-sm mt-2 pb-[calc(56px+env(safe-area-inset-bottom,0px))]">
      <div className="max-w-2xl mx-auto px-4 pt-3 pb-2 text-[11px] text-zinc-500 flex flex-wrap gap-x-3 gap-y-1 justify-center">
        <Link to="/termos" className="hover:text-black">Termos de Uso</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacidade" className="hover:text-black">Privacidade</Link>
        <span aria-hidden="true">·</span>
        <Link to="/regras" className="hover:text-black">Regras da Comunidade</Link>
        <span aria-hidden="true">·</span>
        <Link to="/reembolsos" className="hover:text-black">Reembolsos</Link>
      </div>
      <div className="text-center text-[10px] text-zinc-400 leading-snug px-4 pb-2" data-testid="footer-company">
        © CD NOIR LTD (17360692) — England &amp; Wales
      </div>
      <p className="text-center text-[9px] text-zinc-400 leading-snug px-6 pb-2 max-w-md mx-auto" data-testid="footer-disclaimer">{t("disclaimer")}</p>
    </footer>
  );
}
